export const IS_RESOURCE_ENABLED_FS = 'FS_ENABLE_VERSIONING_FOR_PAGES';

export default { IS_RESOURCE_ENABLED_FS };
